import { Box, Typography } from "@mui/material";
import React from "react";
import PermIdentityIcon from "@mui/icons-material/PermIdentity";

const PageBar = ({ text, vendorId, vendorName, sx }) => {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        backgroundColor: "#EEEEEF",
        borderBottom: "1px solid lightgrey",
        paddingLeft: "1rem",
        paddingRight: "1rem", // Added right padding for symmetry
        paddingBottom: "1rem",
        paddingTop: "3rem", ...sx,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
        }}
      >
        <PermIdentityIcon
          style={{
            color: "#8E9297",
            marginRight: "10px",
            fontSize: "1.4rem",
          }}
        />
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#212832",
          }}
        >
          {text}
        </Typography>
      </Box>
      {vendorId && (
        <Typography
          sx={{
            fontSize: "16px",
            fontWeight: "600",
            color: "#212832",
          }}
        >
          {vendorId} {vendorName && `- ${vendorName}`}
        </Typography>
      )}
    </Box>
  );
};


export default PageBar;
